import { render, staticRenderFns } from "./CustomerBillingStrategies.vue?vue&type=template&id=12fc5ec6&"
import script from "./CustomerBillingStrategies.vue?vue&type=script&lang=js&"
export * from "./CustomerBillingStrategies.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBillingStrategies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports